export enum LocalStorageKeys {
  Gdpr = "ts/gdpr",
  Theme = "ts/theme"
}
